export default __webpack_public_path__ + "static/media/3.4a96cbe9.mp3";